var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{attrs:{"type":"plain"}},[_c('h2',[_vm._t("title")],2),_vm._t("content"),(_vm.$slots.menu)?_c('div',{staticClass:"margin-top-2x line-height-4x"},[_vm._t("menu")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }